import React, { useEffect } from 'react'
import { SET_VIEW } from '../../actions/actionTypes'
import MapIcon from '../../icons/Map.jsx'
import GridIcon from '../../icons/Grid.jsx'
import ListIcon from '../../icons/List.jsx'

export default function Header({ dispatch, dataMeta, view, searchByMoveActive }) {
  const mdBreakpoint = 768;

  // Auto change from list to grid on mobile
  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.matchMedia(`(max-width: ${mdBreakpoint - 1}px)`).matches;
      if (isSmallScreen && view === 'list') {
        dispatch({
          type: SET_VIEW,
          payload: { value: 'grid' },
        });
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dispatch, view]);

  // Disable list selection on mobile
  const toggleView = ( newView ) => {
    const isSmallScreen = window.matchMedia(`(max-width: ${mdBreakpoint - 1}px)`).matches;
    dispatch({
      type: SET_VIEW,
      payload: {
        value: isSmallScreen && newView === 'list' ? 'grid' : newView,
      },
    })
  }

  return (
    <div className={`c-searchHeader ${view === 'map' ? 'c-searchHeader--map' : ''}`}>
      <div className="c-searchHeader__inner d-flex justify-content-between flex-wrap">
        <h2 className="c-searchHeader__heading h4">
          {
            !searchByMoveActive && (
              (dataMeta.to && dataMeta.total) ? (
                <span>Showing {dataMeta.to} of {dataMeta.total}</span>
              ) : (
                <span></span>
              )
            )
          }

          {searchByMoveActive && (
            <span></span>
          )}
        </h2>
        <div className="c-searchHeader__buttons d-flex">
          <div className={`c-searchHeader__button c-searchHeader__button--map ${view === 'map' ? 'c-searchHeader__button--active' : ''}`} onClick={ () => toggleView('map') }>
            <MapIcon />
          </div>
          <div className={`c-searchHeader__button c-searchHeader__button--list ${view === 'list' ? 'c-searchHeader__button--active' : ''}`}  onClick={ () => toggleView('list') }>
            <ListIcon />
          </div>
          <div className={`c-searchHeader__button c-searchHeader__button--grid ${view === 'grid' ? 'c-searchHeader__button--active' : ''}`}  onClick={ () => toggleView('grid') }>
            <GridIcon />
          </div>
        </div>
      </div>
      <hr/>
    </div>
  )
}
